export const signIn = credentials => {
  return (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();

    firebase
      .auth()
      .signInWithEmailAndPassword(credentials.email, credentials.password)
      .then(() => {
        dispatch({ type: "LOGIN_ERROR_RESET" });
      })
      .catch(err => {
        dispatch({ type: "LOGIN_ERROR_MAIL", err });
      });
  };
};

export const resetAuthError = () => {
  return { type: "LOGIN_ERROR_RESET" };
};

export const signOut = () => {
  return (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();

    firebase
      .auth()
      .signOut()
      .then(() => {
        dispatch({ type: "SIGNOUT_SUCCESS" });
        window.location.reload();
      });
  };
};
export const resetRegWarnings = () => {
  return { type: "REG_RESET_WARNINGS" };
};

export const registerWithEmail = credentials => {
  return (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();
    firebase
      .auth()
      .createUserWithEmailAndPassword(credentials.email, credentials.password)
      .then(user => {
        dispatch({ type: "REG_SUCCESS" });
      })
      .catch(err => {
        switch (err.code) {
          case "auth/weak-password":
            dispatch({ type: "REG_ERROR_PASSWORD_TOO_SHORT", err });
            break;
          case "auth/invalid-email":
            dispatch({ type: "REG_ERROR_EMAIL_INV", err });
            break;
          case "auth/email-already-in-use":
            dispatch({ type: "REG_ERROR_EMAIL_USED", err });
            break;
        }
      });
  };
};

export const registerWithFacebook = () => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const provider = new firebase.auth.FacebookAuthProvider();
    firebase
      .auth()
      .signInWithPopup(provider)
      .then(function(result) {
        if (result.credential) {
          // This gives you a Facebook Access Token. You can use it to access the Facebook API.
          const token = result.credential.accessToken;
          // ...
        }
        // The signed-in user info.
        const user = result.user;
        const uid = result.user.uid;
        const isNewUser = result.additionalUserInfo.isNewUser;
        dispatch({ type: "REG_FACE_SUCCESS", isNew: isNewUser });
      })
      .catch(function(error) {
        // Handle Errors here.
        const errorCode = error.code;
        const errorMessage = error.message;
        // The email of the user's account used.
        const email = error.email;
        // The firebase.auth.AuthCredential type that was used.
        const credential = error.credential;
        dispatch({ type: "REG_FACE_ERR", errorCode });
        // ...
      });
  };
};

export const createUser = emptyUser => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();
    const uid = getState().firebase.auth.uid;
    firestore
      .collection("users")
      .doc(uid)
      .set({
        ...emptyUser
      })
      .then(() => {
        dispatch({ type: "CREATE_USER_SUCCESS" });
      })
      .catch(err => {
        dispatch({ type: "CREATE_USER_ERROR", err });
      });
  };
};

export const createProfile = emptyProfile => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();
    const uid = getState().firebase.auth.uid;
    firestore
      .collection("profile")
      .doc(uid)
      .set({
        ...emptyProfile
      })
      .then(() => {
        dispatch({ type: "CREATE_PROFILE_SUCCESS" });
      })
      .catch(err => {
        dispatch({ type: "CREATE_PROFILE_ERROR", err });
      });
  };
};

export const resetPass = email => {
  return (dispatch, getstate, { getFirebase }) => {
    console.log(email);
    
    const firebase = getFirebase();
    firebase.auth().useDeviceLanguage();
    firebase
      .auth()
      .sendPasswordResetEmail(email)
      .then(function() {
        dispatch({ type: "RESET_PASS_SUCCESS" });
        dispatch({ type: "RESET_PASS_WARNING_RESET" });
      })
      .catch(function(error) {
        console.log(error);
        dispatch({ type: "RESET_PASS_ERR", error });
        dispatch({ type: "RESET_PASS_WARNING",error });
      });
  };
};

export const resetPassWarningReset = () => {
  return { type: "RESET_PASS_WARNING_RESET" };
};

export const resetPassErrorReset = () => {
  return { type: "RESET_PASS_ERR" };
};

export const resetFaceNewUser = () => {
  return dispatch => {
    dispatch({ type: "RESET_FACE_NEW_USER" });
  };
};

export const resetFaceNewUserAndProfile = () => {
  return dispatch => {
    dispatch({ type: "RESET_FACE_NEW_USER_PROFILE" });
  };
};

export const resetNewUserAndProfile = () => {
  return dispatch => {
    dispatch({ type: "RESET_NEW_USER_PROFILE" });
  };
};

export const resetRegNewUser = () => {
  return dispatch => {
    dispatch({ type: "RESET_REG_NEW_USER" });
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/authActions.tsx